import { Button } from "@mui/material";
import React from "react";

const RegularLinkButton = ({ iconURL, iconSize, text, altText = "", linkURL, variant = "text", openNewTab = false }) => {
  const icon = iconURL ? (<img src={iconURL} width={iconSize} alt={altText} />) : ''

  const getButton = () => {
    if (openNewTab) {
      return (<Button
        variant={variant}
        href={linkURL}
        color="primary"
        startIcon={icon}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </Button>)
    } else {
      return (<Button
        variant={variant}
        href={linkURL}
        color="primary"
        startIcon={icon}
      >
        {text}
      </Button >)
    }
  }

  return (
    getButton()

  );
};

export default RegularLinkButton;